export const MODAL_TYPE = {
  DISMISS_MODAL: 'dismiss_modal',
  SURVEY_MODAL: 'survey_modal'
};
export const LAB_RESUME_BANNER_REDIRECT_QUERY_PARAM = 'fromResumeBanner';
//# sourceMappingURL=constants.js.map